<div id="carouselExampleIndicators" class="carousel slide carrusel-container-props" data-ride="carousel">

  <div class="carousel-inner adjustContentCarrousel">
    <ng-container *ngFor="let carruselElement of carruselElements; let i = index">
      <div class="carousel-item active" *ngIf="i === 0">
        <div class="row">
          <ng-container *ngFor="let tour of carruselElement">
            <div class="col-lg-4">
              <div class="card mb-4 box-shadow">
                <img *ngIf="tour.imageSanitizer != null" class="card-img-top" [src]="tour.imageSanitizer"
                  alt="Imagen del tour" style="height: 125px; object-fit: cover;">
                <img *ngIf="tour.imageSanitizer == null" class="card-img-top" src="assets/no-image.png"
                  alt="Imagen del tour sin image" style="height: 125px; object-fit: cover;">
                <div class="card-body" style="height: 200px;">
                  <h2 class="justify-content-center truncate" style="font-size: 1em;">
                    {{tour.name}}</h2>
                  <p class="card-text truncate-description" style="height: 75px; font-size: 0.8rem">{{tour.description}}
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary"
                        routerLink='/tour/{{tour.id}}/vista'>Ver</button>
                    </div>
                    <!-- <small class="text-muted">9 mins</small> -->
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="carousel-item" *ngIf="i !== 0">
        <div class="row">
          <ng-container *ngFor="let tour of carruselElement">
            <div class="col-lg-4">
              <div class="card mb-4 box-shadow">
                <img *ngIf="tour.imageSanitizer != null" class="card-img-top" [src]="tour.imageSanitizer"
                  alt="Imagen del tour" style="height: 125px; object-fit: cover;">
                <img *ngIf="tour.imageSanitizer == null" class="card-img-top" src="assets/no-image.png"
                  alt="Imagen del tour sin image" style="height: 125px; object-fit: cover;">
                <div class="card-body" style="height: 200px;">
                  <h2 class="justify-content-center truncate" style="font-size: 1em;">
                    {{tour.name}}</h2>
                  <p class="card-text truncate-description" style="height: 75px; font-size: 0.8rem">{{tour.description}}
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary"
                        routerLink='/tour/{{tour.id}}/vista'>Ver</button>
                    </div>
                    <!-- <small class="text-muted">9 mins</small> -->
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>

  <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
    <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" class="bi bi-caret-left-fill" viewBox="0 0 16 16">
      <path
        d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z" />
    </svg>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
    <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
      <path
        d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
    </svg>
    <span class="sr-only">Next</span>
  </a>
</div>